import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import useService from "../../../Hooks/useService";
import TestScoreService from "../../../../Services/TestScore.service";
import ServiceResult from "../../../UI/ServiceResult/ServiceResult";
import ClientSideTable from "../../../UI/ClientSideTable/ClientSideTable";
import { AlertWarning } from "../../../UI/StandardAlerts/StandardAlerts";
import FileIcon from "../../../UI/FileIcon/FileIcon";
import CustomCard from "../../../UI/CustomCard/CustomCard";
const AdvisorStudentsProgramsTab = (props) => {
    const [testScoreState, loadTestScores] = useService(TestScoreService.getTestScores);
    React.useEffect(() => {
        loadTestScores(props.student.affiliationId);
    }, [loadTestScores, props.student.affiliationId]);
    return (_jsx(ServiceResult, { state: testScoreState, children: (response) => (_jsxs("div", { children: [response.coursePlacementDocumentUrl && (_jsx("div", { className: "mb-2 d-flex justify-content-end", children: _jsxs("a", { className: "btn btn-link", href: response.coursePlacementDocumentUrl, target: "_blank", rel: "noopener noreferrer", children: [_jsx(FileIcon, { extension: "pdf", addMarginRight: true }), "Course Guide"] }) })), response.testScores.length ? (_jsx(CustomCard, { children: _jsx(ClientSideTable, { striped: true, rowVerticalPadding: 2, columns: [
                            { title: "Test" },
                            { title: "Subtest" },
                            { title: "Test Date" },
                            { title: "Score" },
                        ], 
                        // @ts-expect-error - TS2322 - Type '(string | number | null | undefined)[][]' is not assignable to type 'string | number | undefined[][] | null'.
                        sortTable: response.testScores.map((score) => [
                            score.testName,
                            score.subtestName,
                            new Date(score.testDate).getTime(),
                            score.score,
                        ]), rows: response.testScores.map((score) => [
                            score.testName,
                            score.subtestName || null,
                            score.testDate,
                            score.score,
                        ]) }) })) : (_jsx(AlertWarning, { message: "No test scores found for this person" }))] })) }));
};
export default AdvisorStudentsProgramsTab;
